






























































































































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DemoServer from "../../shared/DemoServer";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";
import Notification from "../general/Notification.vue";
import ModulesJson from "../../shared/ModulesJson";
import UserJson from "../../shared/UserJson";
import { UserPermissionRank, UserPermissionRankNames } from "../../shared/UserPermissionRank";
import UserPermission, { defaultUserPermissionJson } from "../../shared/UserPermission";
import { UserPermissionType, UserPermissionTypeNames } from "../../shared/UserPermissionType";
import UserPermissionTypeInfoJson, { UserPermissionTypeInfos } from "../../shared/UserPermissionTypeInfoJson";
import { validateUserJson } from "../../shared/UserJson";
import { ValidationResult, Validation } from "../../shared/Validation";

export default Vue.extend({
  name: "SettingsUserDetails",
  components: {
    OverlayWindow,
    Loading,
    Notification,
  },
  props: {
    restClient: RestClient,
    loginUser: Object as Object as PropType<UserJson>,
    loginId: Number,
    loginPermission: Number,
    allActiveModules: Array as PropType<ModulesJson[]>,
    userDetails: Object,
    mode: String,
  },
  data() {
    return {
      DemoServer: DemoServer,
      editable: false as boolean,
      detailsTitle: "",
      UserPermissionRank: UserPermissionRank,
      UserPermissionRankNames: UserPermissionRankNames,
      UserPermissionType: UserPermissionType,
      UserPermissionTypeNames: UserPermissionTypeNames,
      UserPermissionTypeInfos: UserPermissionTypeInfos,
      detailsMode: "",
      newUserPassword: "",
      hidePassword: true as boolean,
      selectedPermissions: [],
      hasChanges: false,
      toValidate: {} as any,
      validation: null as ValidationResult<UserJson> | null,
      submitValidation: false as boolean,
      showNotificationPermissions: false as boolean,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.selectDetailsMode(this.mode);
  },
  methods: {
    selectDetailsMode(mode: string) {
      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Benutzer:in hinzufügen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Benutzer:in bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Benutzer:in";
          this.editable = false;
          break;
      }
    },

    toggleEditMode() {
      this.editable = !this.editable;
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.userDetails != null) {
        this.validation = validateUserJson(this.userDetails);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    /*** START user permissions ***/

    setUserPermission(permissionType: UserPermissionType, value: boolean) {
      if (this.userDetails != null) {
        if (value) {
          let newPermission = { ...defaultUserPermissionJson() };
          newPermission.type = permissionType;

          this.userDetails.userPermissions.push(newPermission);
        } else {
          let index = this.userDetails.userPermissions.findIndex((i: UserPermission) => i.type === permissionType);

          this.userDetails.userPermissions.splice(index, 1);
        }
      }
    },

    hasUserPermission(permissionType: UserPermissionType) {
      if (this.userDetails != null) {
        let types = this.userDetails.userPermissions.find((i: UserPermission) => i.type === permissionType);

        if (types) {
          return true;
        }

        return false;
      }
    },

    setUserPermissionPermissionRank(permissionType: UserPermissionType, value: UserPermissionRank) {
      if (this.userDetails != null) {
        let index = this.userDetails.userPermissions.findIndex((i: UserPermission) => i.type === permissionType);

        this.userDetails.userPermissions[index].permissionRank = value;
      }
    },

    getUserPermissionPermissionRank(permissionType: UserPermissionType) {
      if (this.userDetails != null) {
        let index = this.userDetails.userPermissions.findIndex((i: UserPermission) => i.type === permissionType);

        return this.userDetails.userPermissions[index].permissionRank;
      }
    },

    setUserPermissionLimitToOwnData(permissionType: UserPermissionType, value: boolean) {
      if (this.userDetails != null) {
        let index = this.userDetails.userPermissions.findIndex((i: UserPermission) => i.type === permissionType);

        this.userDetails.userPermissions[index].limitToOwnData = value;
      }
    },

    getUserPermissionLimitToOwnData(permissionType: UserPermissionType) {
      if (this.userDetails != null) {
        let index = this.userDetails.userPermissions.findIndex((i: UserPermission) => i.type === permissionType);

        return this.userDetails.userPermissions[index].limitToOwnData;
      }
    },

    /*** END user permissions ***/

    async addNewUser() {
      this.loadingGeneral = true;

      this.submitValidation = true;

      this.validation = validateUserJson(this.userDetails);

      if (this.validation != null && this.validation.isValid == true) {
        if (this.restClient != null) {
          try {
            let newUserDetails = await this.restClient.insertUser(this.userDetails);
            if (newUserDetails.ID != null) {
              this.restClient.changePassword(newUserDetails.ID, this.newUserPassword);
              this.hasChanges = false;
              this.loadingGeneral = false;
              this.closeDetails();
              alert("Der/die neue Benutzer:in wurde erfolgreich angelegt.");
            }
          } catch (e) {
            this.loadingGeneral = false;
            alert(e.message);
          }
        }
      } else {
        this.loadingGeneral = false;
        alert("Der/die neue Benutzer:in konnte nicht angelegt werden. Bitte überprüfen Sie Ihre Angaben.");
      }
    },

    async saveUserDetails() {
      if (this.hasChanges) {
        this.loadingGeneral = true;

        if (this.newUserPassword != "") {
          await this.changeUserPassword();
        }

        this.validation = validateUserJson(this.userDetails);

        if (this.validation != null && this.validation.isValid == true) {
          if (this.restClient != null) {
            try {
              let updatedUserDetails = await this.restClient.updateUser(this.userDetails);
              if (this.loginId == updatedUserDetails.ID) {
                this.changeLoginData(updatedUserDetails, null);
              }
              this.hasChanges = false;
              this.loadingGeneral = false;
              alert("Die Änderungen wurden erfolgreich gespeichert.");

              this.showNotificationPermissions = true;
            } catch (e) {
              this.loadingGeneral = false;
              alert(e.message);
            }
          }
        } else {
          this.loadingGeneral = false;
          alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");
        }
      } else {
        alert("Es wurden keine Änderungen vorgenommen.");
        this.closeDetails();
      }
    },

    async changeUserPassword() {
      if (this.userDetails.ID != null) {
        if (this.restClient != null) {
          try {
            await this.restClient.changePassword(this.userDetails.ID, this.newUserPassword);

            if (this.loginId == this.userDetails.ID) {
              this.changeLoginData(null, this.newUserPassword);
            }

            this.newUserPassword = "";
          } catch (e) {
            alert(e.message);
          }
        }
      }
    },

    changeLoginData(updatedUserDetails: UserJson | null, newPassword: string | null) {
      if (updatedUserDetails != null && newPassword == null) {
        this.$emit("change-login-data", updatedUserDetails.email, updatedUserDetails.permissionRank, null);
      } else if (newPassword != null && updatedUserDetails == null) {
        this.$emit("change-login-data", null, null, newPassword);
      } else {
        this.$emit("change-login-data", updatedUserDetails?.email, updatedUserDetails?.permissionRank, newPassword);
      }
    },

    async deleteUser() {
      let c = confirm("Wollen Sie diesen/diese Benutzer:in wirklich unwiderruflich löschen?");
      if (c == true) {
        if (this.restClient != null) {
          try {
            await this.restClient.deleteUser(this.userDetails.ID);
            this.closeDetails();
            alert("Der/die Benutzer:in wurde gelöscht.");
          } catch (e) {
            alert(e.message);
          }
        }
      } else {
        //do nothing
      }
    },
  },
  watch: {
    userDetails: {
      handler() {
        this.hasChanges = true;
      },
      deep: true,
    },
    newUserPassword: {
      handler() {
        this.hasChanges = true;
      },
    },
  },
  computed: {
    hasPermissionOrIsAdmin: function () {
      if (
        this.loginUser.permissionRank > this.userDetails.permissionRank ||
        this.loginUser.permissionRank == this.UserPermissionRank.admin
      ) {
        return true;
      } else {
        return false;
      }
    },

    hasPermissionOrIsAdminOrOwnData: function () {
      if (
        this.loginUser.permissionRank > this.userDetails.permissionRank ||
        this.loginUser.permissionRank == this.UserPermissionRank.admin ||
        this.loginUser.ID == this.userDetails.ID
      ) {
        return true;
      } else {
        return false;
      }
    },

    filteredUserPermissionTypeInfos(): UserPermissionTypeInfoJson[] {
      return this.UserPermissionTypeInfos.filter((i: UserPermissionTypeInfoJson) =>
        this.allActiveModules.some((j: ModulesJson) => j.linkedComponent == i.parentModule)
      );
    },
  },
});
